// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3_bbI","title":"Header_title__2JUgn","side":"Header_side__249Hq"};